import { render, staticRenderFns } from "./BoardCommunity.vue?vue&type=template&id=331d5bd0&scoped=true"
import script from "./BoardCommunity.vue?vue&type=script&lang=js"
export * from "./BoardCommunity.vue?vue&type=script&lang=js"
import style0 from "./BoardCommunity.vue?vue&type=style&index=0&id=331d5bd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331d5bd0",
  null
  
)

export default component.exports